export default __webpack_public_path__ + "static/media/braces-esteticos.6df2ce18.png";